module.exports = __webpack_public_path__ + "static/media/favoritesDefault.7aa8eea6.png";